import { db } from "@/firebase/config.js";
import axios from "axios";
import { FBconsultaToken } from "./tokens";

// --------------------------------------------------------
// Función para guardar el registro en Firebase Firestore
// --------------------------------------------------------
async function saveMessageToDatabase(senderPhoneNumber, messaging, timestamp, contacts, doliente) {
    try {
        const userRef = db.collection("cf-whatsapp").doc(senderPhoneNumber);
        const doc = await userRef.get();

        const newMessage = {
            body: messaging,
            timestamp: timestamp,
            usuario: doliente
        };

        if (doc.exists) {
            // Chat existente: agregamos al array y reordenamos
            const existingMessages = doc.data().messages || [];
            existingMessages.push(newMessage);

            const updatedMessages = existingMessages.sort((a, b) => a.timestamp - b.timestamp);

            await userRef.update({
                messages: updatedMessages,
                mensajePendiente: false
            });
        } else {
            // Chat nuevo: creamos el documento inicial
            await userRef.set({
                messages: [newMessage],
                usuario: contacts || "Usuario Desconocido",
                mensajePendiente: false
            });
        }
    } catch (error) {
        console.error('Error al guardar el mensaje en la base de datos:', error);
    }
}

// --------------------------------------------------------
// Función principal para enviar el mensaje hacia Meta (WhatsApp)
// --------------------------------------------------------
export async function FBenviarMensajeWhatsapp(jsonLlega) {
    try {
        const phoneModificado = jsonLlega.telefonoSelect;
        const TOKEN = await FBconsultaToken();

        const accessToken = TOKEN[0];
        const IDENTIFICADORPHONE = TOKEN[1];

        // Se usa la versión v17.0 (puedes actualizarla a v18.0 o v19.0 en un futuro si lo requieres)
        const apiUrl = `https://graph.facebook.com/v17.0/${IDENTIFICADORPHONE}/messages`;

        // Estructura base del mensaje
        let requestData = {
            messaging_product: "whatsapp",
            recipient_type: "individual",
            to: phoneModificado
        };

        let mensajeGuardar;

        // 1. Lógica para Plantilla vs Mensaje de Texto Normal
        if (jsonLlega.plantilla) {
            requestData.type = "template";
            requestData.template = {
                name: jsonLlega.plantilla,
                language: {
                    code: "es"
                }
            };
            mensajeGuardar = `[Plantilla]: ${jsonLlega.plantilla}`;
        } else {
            requestData.type = "text";
            requestData.text = {
                body: jsonLlega.mensaje
            };
            mensajeGuardar = jsonLlega.mensaje;
        }

        // 2. NUEVA FUNCIONALIDAD: Añadir contexto si se está respondiendo a un mensaje
        if (jsonLlega.contextId) {
            requestData.context = {
                message_id: jsonLlega.contextId
            };
        }

        // 3. Envío de la petición a Meta
        await axios.post(apiUrl, requestData, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });

        // 4. Si el envío es exitoso, guardamos el rastro en Firebase
        const timestamp = new Date();
        await saveMessageToDatabase(
            phoneModificado,
            mensajeGuardar,
            timestamp,
            jsonLlega.contacto,
            jsonLlega.doliente
        );

        return true;

    } catch (error) {
        // Manejo de errores más descriptivo para ayudar a depurar si falla el token o la plantilla
        console.error("Error al enviar el mensaje por WhatsApp:", error.response?.data || error.message);
        return false;
    }
}